<template>
  <v-card
    v-bind="$attrs"
    :style="styles"
    v-on="$listeners"
  >
    <helper-offset
      v-if="hasOffset"
      :inline="inline"
      :full-width="fullWidth"
      :offset="offset"
    >
      <v-card
        v-if="!$slots.offset"
        :color="color"
        :class="`elevation-${elevation}`"
        class="v-card--material__header"
        dark
      >
        <v-container>
          <v-row v-if="isbutton" class="px-0 py-0">
            <v-col cols="9" md="10">
              <slot
                v-if="!title && !text"
                name="header"
              />
              <span v-else>
                <h4
                  class="title font-weight-light mb-2"
                  v-text="title"
                />
                <p
                  class="category font-weight-thin"
                  v-text="text"
                />
              </span>
            </v-col>
            <v-col cols="3" md="2" class="d-flex justify-end align-center pt-0 pl-0 pb-0">
              <v-spacer> </v-spacer>
              <v-progress-circular
                v-show="loading"
                indeterminate
                color="white"
                width="2"
              />
              <slot 
                v-if="!loading"
                name="button"
              />
            </v-col>
            <!--<v-col v-show="loading" cols="3" md="2" class="d-flex justify-end align-center pt-0 pl-0 pb-0">
              
            </v-col>-->
          </v-row>
          <v-row v-else class="px0 py0">
            <v-col cols="12" md="12">
              <slot
                v-if="!title && !text"
                name="header"
              />
              <span v-else>
                <h4
                  class="title font-weight-light mb-2"
                  v-text="title"
                />
                <p
                  class="category font-weight-thin"
                  v-text="text"
                />
              </span>
            </v-col>        
          </v-row>
          </v-container>
      </v-card>
      <slot
        v-else
        name="offset"
      />
      
    </helper-offset>

    <v-card-text>
      <slot />
    </v-card-text>

    <v-divider
      v-if="$slots.actions"
      class="mx-3"
    />

    <v-card-actions v-if="$slots.actions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    color: {
      type: String,
      default: 'secondary'
    },
    elevation: {
      type: [Number, String],
      default: 10
    },
    inline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 24
    },
    title: {
      type: String,
      default: undefined
    },
    text: {
      type: String,
      default: undefined
    },
    isbutton: {
      type: Boolean,
      default: false
    },
    loading: {
      default: false
    }
  },
  watch: {
    loading(novo){
      return novo
    }
  },
  computed: {
    hasOffset () {
      return this.$slots.header ||
        this.$slots.offset ||
        this.title ||
        this.text
    },
    styles () {
      if (!this.hasOffset) return null

      return {
        marginBottom: `${this.offset}px`,
        marginTop: `${this.offset}px`
      }
    }
  }
}
</script>

<style lang="scss">
  .v-card--material {
    &__header {
      &.v-card {
        border-radius: 4px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/material/Card.vue